import { autoinject, bindingMode, customElement, DOM } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { GroupBase } from 'support/base_classes/group-base';

@autoinject
@customElement('bs-form-textarea')
export class FormTextarea extends GroupBase {
  @bindable placeholder = '';
  @bindable({ defaultBindingMode: bindingMode.twoWay }) value: string = null;
  @bindable rows = 1;
  @bindable controlClass = '';
  @bindable disabled = false;
  @bindable maxlength = 524288;
  @bindable autogrow = true;
  @bindable({ defaultBindingMode: bindingMode.twoWay }) hasfocus = false;

  constructor(private element: Element) {
    super();
  }

  blur() {
    this.element.dispatchEvent(DOM.createCustomEvent('blur'));
  }
}
